import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function FamilyCentredPrivateGpCare() {
  return <section data-section-id="226125" id="boots-on-the-ground-in-kansas-city" className="relative bg-background overflow-hidden py-20 lg:py-32">
      {}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-primary/10 rounded-lg blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          {}
          <div className="lg:col-span-7 flex flex-col items-start">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default text-foreground leading-[1.1] tracking-tighter">Reliable Connection & Communications with Local Field Expertise</h1>
            
            <p className="mt-6 text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed font-sans">Kansas City based IT field services and technology sales. We take care of the technical work so you can focus on your business.</p>
            
            <div className="mt-10 flex flex-col sm:flex-row items-center gap-6 w-full sm:w-auto">
              <Button size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground w-full sm:w-auto rounded-sm px-8 h-14 text-base font-bold shadow-lg shadow-primary/20" asChild>
                <Link to="/ContactPage">Schedule Service</Link>
              </Button>
              
              <Link to="/ContactPage" className="text-foreground hover:text-primary font-bold font-default inline-flex items-center gap-2 transition-colors py-3">
                Request Site Survey <ArrowRight className="w-4 h-4" />
              </Link>
            </div>

            {}
            <div className="mt-16 pt-8 border-t border-border flex items-center gap-8 w-full max-w-md">
              <div className="flex flex-col">
                <span className="text-3xl font-bold text-foreground font-default">24HR</span>
                <span className="text-sm text-muted-foreground mt-1 font-mono uppercase tracking-wider">Response Time</span>
              </div>
              <div className="w-px h-12 bg-border"></div>
              <div className="flex flex-col">
                <span className="text-3xl font-bold text-primary font-default">READY</span>
                <span className="text-sm text-muted-foreground mt-1 font-mono uppercase tracking-wider">Status: Deployable</span>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative w-full max-w-lg mx-auto lg:max-w-none">
            {}
            <div className="relative w-full aspect-square rounded-t-none rounded-b-none overflow-hidden shadow-4xl ring-1 ring-white/10 bg-card">
              <img src="https://voltex-it.com/wp-content/uploads/2026/05/network_hardware_setup.webp" alt="Voltex technician terminating Cat6 cable with Kansas City skyline background" className="w-full h-full object-contain grayscale hover:grayscale-0 transition-all duration-700" />
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent mix-blend-multiply"></div>
              
              {}
              <div className="absolute top-6 right-6 bg-primary text-primary-foreground px-4 py-2 rounded-sm font-mono text-xs font-bold flex items-center gap-2 shadow-xl">
                <span className="w-2 h-2 bg-primary-foreground rounded-lg animate-pulse"></span>
                STATUS: READY TO DEPLOY
              </div>
            </div>
            
            {}
            <div className="absolute -bottom-8 -left-8 w-64 h-64 bg-primary/20 rounded-lg blur-3xl -z-10"></div>
          </div>

        </div>
      </div>
    </section>;
}